(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('FacilityDetailsController', FacilityDetailsController);

  /** @ngInject */
  function FacilityDetailsController(
    $scope,
    $stateParams,
    FacilityDetailsViewModel,
    deviceActions,
    broker,
    webSocketsStore,
    $timeout,
    layoutActions,
    $mdDialog,
    $translate,
    messageActions,
    $log
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onDeviceDataChangeHandler = refreshDevice,
      _onFeedChangedHandler = refreshDeviceFeed,
      _onActuatorChangedHandler = refreshDeviceActuator;

    vm.facility = null;
    vm.checkDeviceTypeListener = true;
    vm.checkDeviceTypeBridge = true;
    vm.checkDeviceTypeWashBoxListener = true;
    vm.checkDeviceTypeHHanle = true;
    vm.showQrCode = false;
    vm.buttonTitle = $translate.instant("INSERT");

    init();

    function init() {
      layoutActions.showLoader();

      $scope.$on('$destroy', function () {
        if (vm.facility !== null) {
          vm.facility.destroy();
          webSocketsStore.off(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
        }
      });

      deviceActions.getDevice($stateParams.id).then(
        function (deviceJson) {
          // Check deviceType
          switch (deviceJson.deviceType) {
            case 'SERIAL_485':
              vm.checkDeviceTypeBridge = false;
              break;
            case 'SEMPRA_BRIDGE':
              vm.checkDeviceTypeListener = false;
              vm.checkDeviceTypeWashBoxListener = false;
              break;
            case 'BRIDGE_WITH_LISTENER':
              vm.checkDeviceTypeWashBoxListener = false;
              break;
            case 'HHANLE':
              vm.checkDeviceTypeHHanle = false;
              break;
          }

          layoutActions.hideLoader();

          vm.facility = new FacilityDetailsViewModel(deviceJson);

          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
        },
        function () {
          //todo error handling
        }
      );
    }

    vm.dismissAlarm = function (ev, message) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('DISMISS_ALARM'))
        .ariaLabel('Dismiss alarm confirmation')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('NO'));
      $mdDialog.show(confirm).then(
        function () {
          messageActions.dismissAlarm(message.alarmId).then(function () {
            $log.log('Alarm dismissed');
            messageActions.getAlarmMessages();
          });
        },
        function () {}
      );
    };

    vm.startService = function (ev, box) {
      $mdDialog.show({
        templateUrl: 'app/facilityDetails/insert-token-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        controller: DialogController,
        controllerAs: 'vm',
        bindToController: true,
        locals: {
          box: box,
          facilityId: vm.facility.facility.pointId
        }
      });

      function DialogController($mdDialog, box, managingTokensActions, facilityId, dispatcher, ActionTypesEnum) {
        var vm = this;
        vm.box = box;
        vm.dialogData = {};
        vm.buttonTitle = $translate.instant("IN_PROGRESS");
        vm.sessionStatus = "";

        managingTokensActions.createDeviceSession(box.pointId).then(function (response) {
          vm.sessionStatus = response.data.status;
          vm.buttonTitle = $translate.instant("INSERT");
        })

        vm.closeDialog = function () {
          $mdDialog.cancel();
        };

        vm.saveToken = function (token) {
          if (token && vm.sessionStatus === "PENDING") {
            managingTokensActions.startDeviceService(facilityId, box.pointId, token).then(function () {
              $mdDialog.hide(token);
            })
          } else {
            $mdDialog.hide(token);
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant('EXPIRED_SESSION')
              }
            });
          }
        };
      }
    };

    vm.printQrCode = function () {

      var canvas = document.querySelector('#qrCodeContainer canvas');

      if (!canvas) {
        console.error('QR canvas not found');
        return;
      }

      var image = canvas.toDataURL('image/png');

      var printWindow = window.open('', '_blank');

      printWindow.document.write(
        '<html>' +
          '<head><title>QR Code</title></head>' +
          '<body style="text-align:center; margin-top:50px;">' +
            '<img src="' + image + '" />' +
            '<div style="margin-top:20px; font-size:20px;">' +
              vm.facility.facility.pointId +
            '</div>' +
          '</body>' +
        '</html>'
      );

      printWindow.document.close();

      printWindow.onload = function () {
        printWindow.print();
        printWindow.close();
      };
    };

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToDeviceChanges([vm.facility.deviceSerial]);
        broker.subscribeToFeedChanges([vm.facility.deviceSerial]);
        broker.subscribeToActuatorChanges([vm.facility.deviceSerial]);
      }
    }

    function refreshDevice(newDeviceData) {
      $timeout(function () {
        vm.facility.refreshState(newDeviceData);
      }, 50);
    }

    function refreshDeviceFeed(newFeedData) {
      $timeout(function () {
        vm.facility.refreshFeed(newFeedData);
        $scope.$apply();
      }, 50);
    }

    function refreshDeviceActuator(newActuatorData) {
      $timeout(function () {
        vm.facility.refreshActuator(newActuatorData);
      }, 50);
    }
  }
})();
